import gql from 'graphql-tag';

export const ConsentCookies = gql`
  mutation consentCookies($version: String!) {
    consentCookies(version: $version) {
      result
    }
  }
`;
